import angular from 'angular';
import { MeurhSolicitacoesadiantamentosavulsosService } from './solicitacoesadiantamentosavulsos.service';
import { ListagemService } from '../../../shared/services/listagem.service';

export const AdiantamentosAvulsosRouting = ['$stateProvider', function ($stateProvider: angular.ui.IStateProvider) {
  const resolve = {
    'entity': [
        'MeurhSolicitacoesadiantamentosavulsosService',
        'ListagemService',
        '$rootScope',
        '$stateParams',
        '$state',
        '$q',
        function (
            entityService: MeurhSolicitacoesadiantamentosavulsosService,
            listagemService: ListagemService,
            $rootScope: angular.IRootScopeService & {
                session: any,
                liberadoTela: (arg: string) => boolean
            },
            $stateParams: angular.ui.IStateParamsService,
            $state: angular.ui.IStateService,
            $q: angular.IQService
        ) {
            if (!$stateParams['solicitacao']) {
                return $q<void>(() => $state.go('meurh_solicitacoesadiantamentosavulsos'));
            }

            return entityService.get($stateParams['solicitacao'])
                .then((data) => {
                    const visibilidadeLiberada = $rootScope.liberadoTela('LIBERAR_REFATORACAO_VISIBILIDADE');
                    const empresaNoGrupo = listagemService.getEmpresa(data.empresaobj.empresa);
                    const mesmoEstabelecimento = data.estabelecimentoobj.estabelecimento === $rootScope.session.entities.estabelecimento.estabelecimento;

                    const deveRedirecionar = (
                        (visibilidadeLiberada && !empresaNoGrupo) ||
                        (!visibilidadeLiberada && !mesmoEstabelecimento)
                    );

                    if (deveRedirecionar) {
                        return $q(() => $state.go('meurh_solicitacoesadiantamentosavulsos'));
                    }

                    return data;
                })
                .catch((error) => {
                    if (error.status === 404) {
                        return $q(() => {
                            if ($state.href('meurh_solicitacoesadiantamentosavulsos_not_found', $stateParams)) {
                                $state.go('meurh_solicitacoesadiantamentosavulsos_not_found', $stateParams);
                            } else {
                                $state.go('not_found', $stateParams);
                            }
                        });
                    }

                    return $q.reject(error);
                });
        }
    ]
  };

  $stateProvider
    .state('meurh_solicitacoesadiantamentosavulsos', {
      url: '/solicitacoes/adiantamentos-avulsos?q',
      template: require('html-loader!./index/solicitacoesadiantamentosavulsos.index.html'),
      controller: 'Meurh\SolicitacoesadiantamentosavulsosListController',
      controllerAs: 'mrh_slctcsdntmntsvlss_lst_cntrllr',
      reloadOnSearch: false
    })
    .state('meurh_solicitacoesadiantamentosavulsos_new', {
      parent: 'meurh_solicitacoesadiantamentosavulsos',
      url: '/new',
      template: require('html-loader!./new/solicitacoesadiantamentosavulsos.new.html'),
      controller: 'MeurhSolicitacoesadiantamentosavulsosFormNewController',
      controllerAs: 'mrh_slctcsdntmntsvlss_frm_nw_cntrllr'
    })
    .state('meurh_solicitacoesadiantamentosavulsos_show', {
      parent: 'meurh_solicitacoesadiantamentosavulsos',
      url: '/:solicitacao?path',
      resolve,
      template: require('html-loader!./show/solicitacoesadiantamentosavulsos.show.html'),
      controller: 'MeurhSolicitacoesadiantamentosavulsosFormShowController',
      controllerAs: 'mrh_slctcsdntmntsvlss_frm_shw_cntrllr'
    })
    .state('meurh_solicitacoesadiantamentosavulsos_edit', {
      parent: 'meurh_solicitacoesadiantamentosavulsos',
      url: '/:solicitacao/edit',
      resolve,
      template: require('html-loader!./edit/solicitacoesadiantamentosavulsos.edit.html'),
      controller: 'Meurh\SolicitacoesadiantamentosavulsosFormController',
      controllerAs: 'mrh_slctcsdntmntsvlss_frm_edit_cntrllr'
    });
}];
